import React from 'react';
import { parseEm } from '../inlineEm';

export const warmInlineEm = (text: string) =>
  parseEm(text, (children, key) => (
    <em key={key} className="warm-em">
      {children}
    </em>
  ));
